import gql from 'graphql-tag'

export const GET_LOGGED_USER = gql`
  query getLoggedUser {
    me {
      firstName
      lastName
      email
      id
      type
      flags
      ticketSellerOrganizationId
      isVerifiedByCoreEvent
      hasSeenOnboarding
      notificationSettings
    }
  }
`

export const GET_DEFAULT_ORGANIZATION = gql`
  query getDefaultOrganization {
    getDefaultOrganization {
      id
      slug
      type
    }
  }
`

export const GET_TICKET_SELLER_ORGANIZATION = gql`
  query GetTicketSellerOrganization {
    getTicketSellerOrganization {
      id
      type
    }
  }
`

export const USER_HAS_FINISHED_ONBOARDING = gql`
  mutation userHasFinishedOnboarding {
    userHasFinishedOnboarding
  }
`

export const UPDATE_MY_ACCOUNT_INFO = gql`
  mutation UpdateMyAccountInfo($accountInfo: UpdateAccountInfoInput!) {
    updateMyAccountInfo(accountInfo: $accountInfo)
  }
`
export const UPDATE_MY_NOTIFICATION_SETTINGS = gql`
  mutation UpdateMyNotificationSettings($notificationSettings: UpdateNotificationSettingsInput!) {
    updateMyNotificationSettings(notificationSettings: $notificationSettings)
  }
`

export const DELETE_MY_ACCOUNT = gql`
  mutation DeleteMyAccount {
    deleteMyAccount
  }
`
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($oldPassword: String, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
  }
`

export const GET_TICKET_SELLERS = gql`
  query GetTicketSellers {
    getTicketSellers {
      name
      id
      type
    }
  }
`
export const GET_NON_BOX_OFFICE_TICKET_SELLERS = gql`
  query GetNonBoxOfficeTicketSellers($organizationSlug: String!) {
    getNonBoxOfficeTicketSellers(organizationSlug: $organizationSlug) {
      name
      id
      type
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($userInfo: UpdateUserInput!) {
    updateUser(userInfo: $userInfo)
  }
`

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($status: Boolean!, $userId: ID!) {
    updateUserStatus(status: $status, userId: $userId)
  }
`

export const CREATE_USER = gql`
  mutation CreateUser($userInfo: CreateUserInput!) {
    createUser(userInfo: $userInfo)
  }
`

export const CREATE_TRIAL_ACCOUNT = gql`
  mutation CreateTrialAccount($userInfo: CreateTrialUserInput!) {
    createTrialAccount(userInfo: $userInfo)
  }
`

export const SIGN_UP = gql`
  mutation signUp($userInfo: SignUpInput!, $inviteToken: String) {
    signUp(userInfo: $userInfo, inviteToken: $inviteToken)
  }
`

export const CONFIRM_EMAIL = gql`
  mutation confirmEmail($token: String!) {
    confirmEmail(token: $token)
  }
`
export const UPDATE_ATTENDEE_STATUS = gql`
  mutation updateAttendeeStatus($eventId: ID!, $attendeeUUID: String!, $status: AttendeeStatus!) {
    updateAttendeeStatus(eventId: $eventId, attendeeUUID: $attendeeUUID, status: $status) {
      id
    }
  }
`
export const UPDATE_ANNUAL_TICKET_INVITE_ATTENDEE_STATUS = gql`
  mutation UpdateAnnualTicketInviteAttendeeStatus(
    $eventId: ID!
    $attendeeUUID: String!
    $status: AttendeeStatus!
  ) {
    updateAnnualTicketInviteAttendeeStatus(
      eventId: $eventId
      attendeeUUID: $attendeeUUID
      status: $status
    ) {
      id
    }
  }
`
